export interface ICases {
  name: string;
  value: string;
}

export const casesArray: ICases[] = [
  { name: "Is Equal", value: "isequal" },
  { name: "Is Not Equal", value: "isnotequal" },
  { name: "Greater Than", value: "greaterthan" },
  { name: "Less Than", value: "lessthan" },
  { name: "Is Between", value: "isbetween" },
  { name: "Is Set", value: "isset" },
  { name: "Is Not Set", value: "isnotset" },
  { name: "today", value: "today" },
  { name: "On Or Before", value: "onorbefore" },
  { name: "On Or After", value: "onorafter" },
  { name: "Within The Last", value: "withinthelast" },
  { name: "Within The Next", value: "withinthenext" },
  { name: "Any Value", value: "anyvalue" },
  { name: "Contains", value: "contains" },
];

export const IcfTDropdownCasesArray
  // : IcfTDropdownCases[] 
  = [
    { name: "Is Equal", value: "isequal" },
    { name: "Is Not Equal", value: "isnotequal" },
    { name: "Is Set", value: "isset" },
    { name: "Is Not Set", value: "isnotset" },
  ];

export const IcfTDateCasesArray
  // : IcfTDateCases[] 
  = [
    { name: "Is Equal", value: "isequal" },
    { name: "Is Not Equal", value: "isnotequal" },
    { name: "Is Between", value: "isbetween" },
    { name: "Is Set", value: "isset" },
    { name: "Is Not Set", value: "isnotset" },
    { name: "Today", value: "today" },
    { name: "On Or Before", value: "onorbefore" },
    { name: "On Or After", value: "onorafter" },
    { name: "Within The Last", value: "withinthelast" },
    { name: "Within The Next", value: "withinthenext" },
  ];

export const IcfTStringCasesArray
  // : IcfTStringCases[] 
  = [
    { name: "Is Equal", value: "isequal" },
    { name: "Is Not Equal", value: "isnotequal" },
    { name: "Contains", value: "contains" },
    { name: "Is Set", value: "isset" },
    { name: "Is Not Set", value: "isnotset" },
  ];

export const IcfTIntegerCasesArray
  // : IcfTIntegerCases[] 
  = [
    { name: "Is Equal", value: "isequal" },
    { name: "Is Not Equal", value: "isnotequal" },
    { name: "Greater Than", value: "greaterthan" },
    { name: "Less Than", value: "lessthan" },
    { name: "Is Between", value: "isbetween" },
    { name: "Is Set", value: "isset" },
    { name: "Is Not Set", value: "isnotset" },
  ];

export const IcfTToggleCasesArray
  // : IcfTToggleCases[] 
  = [
    { name: "Is Equal", value: "isequal" },
    { name: "Is Not Equal", value: "isnotequal" },
    { name: "Is Set", value: "isset" },
    { name: "Is Not Set", value: "isnotset" },
  ];

  

export const EqualityDisplayValue = {
  isEqual: "Is Equal",
  isNotEqual: "Is Not Equal",
  greaterThan: "Greater Than", 
  lessThan: "Less Than",
  isBetween: "Is Between",
  isSet: "Is Set",
  isNotSet: "Is Not Set",
  today: "Today",
  onOrBefore: "On Or Before",
  onOrAfter: "On Or After",
  withinTheLast: "Within The Last",
  withinTheNext: "Within The Next",
  anyValue: "Any Value",
  contains: "Contains"
} as const;

export const EqualityDisplayValueArray = Object.values(EqualityDisplayValue);

export const Equality = {
  isEqual: "Is Equal",
  isNotEqual: "Is Not Equal",
  greaterThan: "Greater Than", 
  lessThan: "Less Than",
  isBetween: "Is Between",
  isSet: "Is Set",
  isNotSet: "Is Not Set",
  today: "Today",
  onOrBefore: "On Or Before",
  onOrAfter: "On Or After",
  withinTheLast: "Within The Last",
  withinTheNext: "Within The Next",
  anyValue: "Any Value",
  contains: "Contains"
} as const;

export const EqualityNumber = {
  isEqual: 0,
  isNotEqual: 1, 
  greaterThan: 2,
  lessThan: 3,
  isBetween: 4,
  isSet: 5,
  isNotSet: 6,
  today: 7,
  onOrBefore: 8,
  onOrAfter: 9,
  withinTheLast: 10,
  withinTheNext: 11,
  anyValue: 12,
  contains: 13
} as const;

export const turnEqualityValueToNumber = (equalityValue: string): number => {
  const sanitizedValue = equalityValue.trim().toLowerCase().replace(/\s+/g, "");
  
  switch (sanitizedValue) {
    case "isequal": return EqualityNumber.isEqual;
    case "isnotequal": return EqualityNumber.isNotEqual;
    case "greaterthan": return EqualityNumber.greaterThan;
    case "lessthan": return EqualityNumber.lessThan;
    case "isbetween": return EqualityNumber.isBetween;
    case "isset": return EqualityNumber.isSet;
    case "isnotset": return EqualityNumber.isNotSet;
    case "today": return EqualityNumber.today;
    case "onorbefore": return EqualityNumber.onOrBefore;
    case "onorafter": return EqualityNumber.onOrAfter;
    case "withinthelast": return EqualityNumber.withinTheLast;
    case "withinthenext": return EqualityNumber.withinTheNext;
    case "anyvalue": return EqualityNumber.anyValue;
    case "contains": return EqualityNumber.contains;
    default: return EqualityNumber.isEqual;
  }
}

export const turnNumberToEqualityValue = (numberValue: number): string => {
  const equalityValues = [
    "isEqual",
    "isNotEqual",
    "greaterThan",
    "lessThan",
    "isBetween",
    "isSet",
    "isNotSet",
    "today",
    "onOrBefore",
    "onOrAfter",
    "withinTheLast",
    "withinTheNext",
    "anyValue",
    "contains"
  ];
  console.log(numberValue)
  const newValue: any = equalityValues[numberValue]
  console.log(equalityValues[numberValue - 1])

  // Ensure the number is within the valid range of indices
  if (numberValue >= 0 && numberValue < equalityValues.length) {
    console.log(equalityValues[numberValue - 1]);
    return equalityValues[numberValue - 1];
  } else {
    console.log("default");
    return "isequal"; // Default case if the number is out of range
  }
}


export const turnOldNumberToEqualityValue = (numberValue: number): string => {
  if (numberValue === 0) {
    return "isNotEqual"
  } else if (numberValue === 1) {
    return "isEqual"
  }
  return ''
}

export const turnEqualityValueToDisplayValue = (equalityValue: string) => {
  //sanatize equalityValue to trim and be lowercase
  // equalityValue = equalityValue.trim().toLowerCase().replace(/\s+/g, "");
  console.log(equalityValue)
  switch (equalityValue) {
    case "isequal":
      console.log("isEqual");
      return "Is Equal";

    case "isnotequal":
      console.log("isNotEqual");
      return "Is Not Equal";

    case "greaterthan":
      console.log("greaterThan");
      return "Greater Than";

    case "lessthan":
      console.log("lessThan");
      return "Less Than";

    case "isbetween":
      console.log("isBetween");
      return "Is Between";

    case "isset":
      console.log("isSet");
      return "Is Set";

    case "isnotset":
      console.log("isNotSet");
      return "Is Not Set";

    case "today":
      console.log("today");
      return "Today";

    case "onorbefore":
      console.log("onOrBefore");
      return "On Or Before";

    case "onorafter":
      console.log("onOrAfter");
      return "On Or After";

    case "withinthelast":
      console.log("withinTheLast");
      return "Within The Last";

    case "withinthenext":
      console.log("withinTheNext");
      return "Within The Next";

    case "anyvalue":
      console.log("anyValue");
      return "Any Value";

    case "contains":
      console.log("contains");
      return "Contains";

    // default:
    //   console.log("default");
    //   return 'Is Equal';
  }
}